export default __webpack_public_path__ + "static/assets/a6c550da06b8cbea2b694b719f90fa8f.gif";